module.exports = __webpack_public_path__ + "static/img/A119.b691e4df.jpg";